import { styled } from '@/stitches.config';

import { Box } from '@base-app';

import { ReactComponent as Expand } from '@/assets/icons/expand.svg';
import { ReactComponent as Collapse } from '@/assets/icons/collapse.svg';
import { Variants } from '@/common/types';

export const StyledCollapsibleSectionContainer = styled(Box, {
  backgroundColor: '$white',
  borderRadius: '$8',
  boxShadow: '$studyInsights$shadowBox',
  height: 'max-content',
  padding: '$6',

  variants: {
    isCollapsed: {
      true: {
        height: 'min-content',
      },
    },
    variant: {
      [Variants.PRIMARY]: {},
      [Variants.SECONDARY]: {
        backgroundColor: '$warmGray700',
        border: '$borderWidths$1 solid $warmGray300',
      },
      [Variants.TERTIARY]: {},
    },
  },
});

export const StyledSectionTitle = styled(Box, {
  alignItems: 'flex-start',
  color: '$darkBlue300',
  display: 'flex',
  fontSize: '$xl',
  fontWeight: '$bold',
  justifyContent: 'space-between',
  marginBottom: '$5',
  maxHeight: '$10',

  variants: {
    isCollapsed: {
      true: {
        marginBottom: 0,
      },
    },
    variant: {
      [Variants.PRIMARY]: {},
      [Variants.SECONDARY]: {
        marginBottom: '$4',
        borderBottom: '$borderWidths$1 solid $warmGray300',
      },
      [Variants.TERTIARY]: {},
    },
  },
  compoundVariants: [
    {
      isCollapsed: true,
      variant: Variants.SECONDARY,
      css: {
        borderBottom: 'none',
        marginBottom: 0,
      },
    },
  ],
});

export const StyledTitle = styled(Box, {
  variants: {
    isCollapsed: {
      true: {
        marginBottom: 0,
      },
    },
    variant: {
      [Variants.PRIMARY]: {},
      [Variants.SECONDARY]: {
        fontSize: '$md',
        marginBottom: '$4',
      },
      [Variants.TERTIARY]: {},
    },
  },
  compoundVariants: [
    {
      isCollapsed: true,
      variant: Variants.SECONDARY,
      css: {
        marginBottom: 0,
      },
    },
  ],
});

export const StyledCollapsibleContainer = styled(Box, {
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  fontSize: '$normal',
});

export const StyledCollapseContent = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  gap: '$1',
});

export const ExpandIcon = styled(Expand, {
  color: '$black',
  height: '$4',
  width: '$4',
});

export const CollapseIcon = styled(Collapse, {
  color: '$black',
  height: '$4',
  width: '$4',
});
